module.exports = __webpack_public_path__ + "img/word.bcb7cfd.png";